import { render, staticRenderFns } from "./AppointmentService.vue?vue&type=template&id=ed1db702&"
import script from "./AppointmentService.vue?vue&type=script&lang=js&"
export * from "./AppointmentService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports